module.exports = __webpack_public_path__ + "img/editor-bg.d18cff5b.png";